import React, { Fragment } from "react"
import { Icon, Section, Container, Enlace, Logo } from "./styles"

export const Footer = () => {
  return (
    <Fragment>
      <Section>
        {/* <Logo viewBox="0 0 84.6 9">
          <path
            fill="#444242"
            stroke="#fff"
            strokeMiterlimit={10}
            d="M345.3-286.6h308v146h-308z"
          />
          <path d="M0 .2h1l2.8 4.3L6.6.2h1l-3.4 5v3.5h-.8V5.2L0 .2zm10.8 0l3.4 8.6h-.9l-1-2.7H8.4l-1 2.7h-.9L9.9.2h.9zM12 5.4L10.3 1 8.6 5.4H12zM15.9.2l5 7.2V.2h.8v8.6h-.9l-5-7.2v7.2H15V.2h.9zM31 .2l3.2 8.6h-2l-.6-1.9h-3.2l-.7 1.9h-1.9L29 .2h2zm.1 5.3L30 2.3l-1.1 3.1h2.2zM38.6.2c.6 0 1.1.1 1.5.3.5.2.9.4 1.2.8.3.4.6.8.8 1.3.2.5.3 1.1.3 1.9 0 .6-.1 1.2-.2 1.7s-.4 1-.7 1.4c-.3.4-.7.7-1.2.9-.5.2-1.1.3-1.7.3h-3.7V.2h3.7zm-.1 7c.3 0 .5 0 .8-.1.3-.1.5-.3.7-.5.2-.2.4-.5.5-.8.1-.3.2-.7.2-1.2 0-.4 0-.8-.1-1.2-.1-.3-.2-.6-.4-.9-.2-.2-.4-.4-.8-.6-.3-.1-.7-.2-1.2-.2h-1.3v5.4h1.6zm10-7c.4 0 .7.1 1 .2s.6.3.8.5c.2.2.4.5.5.8.1.2.2.5.2.9 0 .5-.1.9-.3 1.3-.2.4-.6.6-1 .8.1.1.3.2.5.3.2.1.3.3.4.5.1.2.2.4.2.6 0 .2.1.4.1.6v1.1c0 .2.1.4.1.5s.1.3.2.4h-1.9c-.1-.3-.2-.6-.2-1S49 7 49 6.6c-.1-.4-.2-.8-.4-1-.2-.2-.5-.3-1-.3h-1.9v3.3h-1.9V.2h4.7zm-.7 3.9c.4 0 .8-.1 1-.3s.3-.5.3-.9-.1-.7-.3-.9-.5-.3-1-.3h-2.1v2.4h2.1zm4.6-1.4c.2-.5.5-1 .8-1.4.4-.4.8-.7 1.3-1s1.2-.3 1.8-.3c.7 0 1.3.1 1.8.3s1 .6 1.3 1c.4.4.6.9.8 1.4.2.5.3 1.1.3 1.8 0 .6-.1 1.2-.3 1.7-.2.5-.5 1-.8 1.4-.4.4-.8.7-1.3.9S57 9 56.3 9s-1.2-.1-1.8-.3-1-.5-1.3-.9c-.4-.4-.6-.9-.8-1.4-.2-.5-.3-1.1-.3-1.7 0-.8.1-1.4.3-2zm1.7 2.9c.1.3.2.6.4.9.2.3.5.5.8.6s.7.2 1.1.2c.4 0 .8-.1 1.1-.2s.5-.4.7-.7.3-.6.4-.9c.1-.3.1-.7.1-1 0-.4 0-.7-.1-1.1s-.2-.7-.4-.9c-.2-.3-.5-.5-.8-.7s-.7-.2-1.1-.2c-.4 0-.8.1-1.1.2s-.5.4-.7.7c-.2.3-.3.6-.4.9s-.1.7-.1 1.1c0 .4.1.7.1 1.1zm9.6 3.2L60.9.2h1.9l1.9 6 1.9-6h1.9l-2.8 8.6h-2zM75.8.2v1.6h-4.5v1.8h4.2v1.5h-4.2v2.1h4.6v1.6h-6.5V.2h6.4zm6 0c.4 0 .7.1 1 .2s.6.3.8.5c.2.2.4.5.5.8.1.3.2.6.2.9 0 .5-.1.9-.3 1.3-.2.4-.6.6-1 .8l.6.3c.2.1.3.3.4.5.1.2.2.4.2.6 0 .2.1.4.1.6v1.1c0 .2.1.4.1.5s.1.3.2.4h-1.9c-.1-.3-.2-.6-.2-1s-.1-.7-.1-1.1c-.1-.4-.2-.8-.4-1-.2-.2-.5-.3-1-.3h-1.9v3.3h-1.9V.2h4.6zm-.7 3.9c.4 0 .8-.1 1-.3s.3-.5.3-.9-.1-.7-.3-.9-.5-.3-1-.3H79v2.4h2.1z" />
        </Logo> */}
        <Container>
          <Enlace
            href="https://open.spotify.com/artist/21KnKWOArXxW0IdRJUUsYB?si=sdB6x56yQKi4hwyYJVFs-Q"
            target="_blank"
          >
            <Icon
              aria-hidden="true"
              data-prefix="fab"
              data-icon="spotify"
              viewBox="0 0 496 512"
              className="prefix__svg-inline--fa prefix__fa-spotify prefix__fa-w-16"
            >
              <path
                fill="currentColor"
                d="M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm100.7 364.9c-4.2 0-6.8-1.3-10.7-3.6-62.4-37.6-135-39.2-206.7-24.5-3.9 1-9 2.6-11.9 2.6-9.7 0-15.8-7.7-15.8-15.8 0-10.3 6.1-15.2 13.6-16.8 81.9-18.1 165.6-16.5 237 26.2 6.1 3.9 9.7 7.4 9.7 16.5s-7.1 15.4-15.2 15.4zm26.9-65.6c-5.2 0-8.7-2.3-12.3-4.2-62.5-37-155.7-51.9-238.6-29.4-4.8 1.3-7.4 2.6-11.9 2.6-10.7 0-19.4-8.7-19.4-19.4s5.2-17.8 15.5-20.7c27.8-7.8 56.2-13.6 97.8-13.6 64.9 0 127.6 16.1 177 45.5 8.1 4.8 11.3 11 11.3 19.7-.1 10.8-8.5 19.5-19.4 19.5zm31-76.2c-5.2 0-8.4-1.3-12.9-3.9-71.2-42.5-198.5-52.7-280.9-29.7-3.6 1-8.1 2.6-12.9 2.6-13.2 0-23.3-10.3-23.3-23.6 0-13.6 8.4-21.3 17.4-23.9 35.2-10.3 74.6-15.2 117.5-15.2 73 0 149.5 15.2 205.4 47.8 7.8 4.5 12.9 10.7 12.9 22.6 0 13.6-11 23.3-23.2 23.3z"
              />
            </Icon>
          </Enlace>
          <Enlace href="https://www.youtube.com/c/YanAdrover" target="_blank">
            <Icon
              aria-hidden="true"
              focusable="false"
              data-prefix="fab"
              data-icon="youtube"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
              className="svg-inline--fa fa-youtube fa-w-18"
            >
              <path
                fill="currentColor"
                d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
                className
              />
            </Icon>
          </Enlace>
          <Enlace href="https://www.instagram.com/yanadrover/" target="_blank">
            <Icon
              aria-hidden="true"
              focusable="false"
              data-prefix="fab"
              data-icon="instagram"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
              className="svg-inline--fa fa-instagram fa-w-14"
            >
              <path
                fill="#FFF"
                d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
                className=""
              ></path>
            </Icon>
          </Enlace>
          <Enlace href="https://www.facebook.com/adroveryan/" target="_blank">
            <Icon
              aria-hidden="true"
              focusable="false"
              data-prefix="fab"
              data-icon="facebook-square"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
              className="svg-inline--fa fa-facebook-square fa-w-14"
            >
              <path
                fill="currentColor"
                d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"
                className=""
              ></path>
            </Icon>
          </Enlace>
        </Container>
      </Section>
    </Fragment>
  )
}
